export default [
  {
    Header: 'Ordem',
    id: 'order',
    accessor: 'order',
    width: 100,
    sortMethod: (a: number, b: number, isSortedDesc: boolean) => {
      if (a === null && b === null) {
        return 0
      }
      if (a === null) {
        return isSortedDesc ? -1 : 1
      }
      if (b === null) {
        return isSortedDesc ? 1 : -1
      }
      return a - b
    },
  },
  {
    Header: 'Código de Barras',
    id: 'barcode',
    accessor: 'barcode',
    width: 300,
  },
  {
    Header: 'Tipo',
    id: 'type',
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'Caixaria',
    id: 'packQty',
    accessor: 'packQty',
    width: 100,
  },
  {
    Header: 'Subir ordem',
    id: 'upOrder',
    accessor: 'upOrder',
    width: 100,
    sortable: false,
  },
  {
    Header: 'Descer ordem',
    id: 'downOrder',
    accessor: 'downOrder',
    width: 100,
    sortable: false,
  },
]
